import { Fragment } from "react";

import useAccountCreationYouthContact from "./useAccountCreationYouthContact";

import YouthContactForm from "../../components/forms/YouthContactForm";

import Headings from "@usas/ui-web/components/headings/Headings";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import Constants from "@usas/ui-web/utils/Constants";
import style from '../../../../LandingPages.module.css';

const AccountCreationYouthContact = () => {
  const {
    youthContactData,
    isLoading,
    apiErrorPopupState,
    onBackClicked,
    onCloseAPIErrorPopupClicked,
    onSubmitFormCallback
  } = useAccountCreationYouthContact();

  return (
    <Fragment>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12 col-md-3" />
        <div className={['col-xs-12', 'col-md-6', style.CenterPageContent].join(' ')}>
          <Headings.H3>Your Contact Information</Headings.H3>
          <p>Please provide an email address and phone number that we can use for account verification.
            If you do not have your own email address, please provide your parent&#39;s email address.
          </p>
          <YouthContactForm
            youthContactData={youthContactData}
            onSubmitFormCallback={onSubmitFormCallback}
            onSecondaryButtonClicked={onBackClicked} />
        </div>
        <div className="col-xs-12 col-md-3" />
      </div>
      <PopUpModal
        widthPct={60}
        maxWidth={720}
        title={'Error'}
        displayPopUp={apiErrorPopupState.displayPopup === true}>
        <div className="row">
          <div className="col-xs-12">
            <p>{apiErrorPopupState.errorMessage || 'An error occurred.'}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <SecondaryButton type={'button'} onClick={onCloseAPIErrorPopupClicked}>Close</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default AccountCreationYouthContact;